import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";

// UserProfilePage element host. Previously seeded four SmartFeed
// feed-store instances (`SmartFeed/stores/feed/...`) from `created()`
// to populate the user's published / commented / loved / voted story
// feeds. Those imports live outside the dynamic-component-editor
// directory tree and don't exist in Studio. The dynamic-component-
// editor isolation rule forbids them — and edit-mode rendering only
// reads the example entity anyway, so the feed setup was dead code
export const UserProfilePageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  data() {
    return {
      defaultFallbackSrc: "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/avatar-default.png",
    };
  },
  created() {
    if (this.editMode || !this.entityId) {
      return;
    }
    useGeneralStore().setUserProfileData(this.entityId);
  },
  methods: {
    getExampleEntity() {
      return {
        "userId": this.entityId,
        "username": "John Smith",
        "bio": "I am a creator on inspiration.co",
        "avatarUrl": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/john-smith-profile-picture.webp",
        "splashImageUrl": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/publication/publication-blog.webp",
        "dateCreated": Date.now() / 1000,
        "dateUpdated": Date.now() / 1000,
        "status": "active",
        "primaryOrgId": 0,
        "followStatus": "inactive",
      };
    },
    getRealEntity() {
      const generalStore = useGeneralStore();
      if (this.entityId) {
        return generalStore.userProfiles[this.entityId] ?? {};
      }
      if (!generalStore.userId) {
        return {};
      }
      return {
        userId: generalStore.userId,
        username: generalStore.username,
        bio: generalStore.userBio,
        avatarUrl: generalStore.userAvatar,
        splashImageUrl: generalStore.userSplashImage,
        dateCreated: generalStore.userData.date_created,
        dateUpdated: generalStore.userData.date_updated,
        status: generalStore.userData.status,
        primaryOrgId: generalStore.orgId,
        followStatus: "inactive",
      };
    },
  },
};
